import Accordion from "../../utils/accordion";

const accordions = () => {
  document.querySelectorAll('details').forEach((el) => {
    new Accordion(el);
  });
}

export default accordions;